var _g, _g2, _path, _path2, _circle, _path3, _path4, _path5, _path6, _circle2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCastingCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 935,
    height: 940,
    viewBox: "0 0 935 940",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_707_130)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 465.5,
    cy: 469.5,
    r: 349.5,
    stroke: "#86FBF0",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.973 84.0119C540.829 83.3935 617.982 106.942 683.052 151.489C748.123 196.036 797.988 259.445 825.939 333.183",
    stroke: "#86FBF0",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.404 855.832C413.1 857.703 350.308 843.969 293.566 815.841C236.823 787.714 187.873 746.057 151.032 694.544",
    stroke: "#86FBF0",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.391 670.883C110.212 629.568 93.0238 583.888 84.7231 536.223",
    stroke: "#86FBF0",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.49 450.168C848.861 418.496 843.335 387.147 834.036 356.827",
    stroke: "#86FBF0",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 465,
    cy: 470,
    r: 372,
    stroke: "#86FBF0",
    strokeWidth: 4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_707_130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471.246 169.69L737.137 314.714C740.992 316.816 743.391 320.857 743.391 325.248V613.752C743.391 618.143 740.992 622.184 737.137 624.286L471.246 769.31C467.664 771.263 463.336 771.263 459.754 769.31L193.863 624.286C190.007 622.184 187.609 618.143 187.609 613.752V325.248C187.609 320.857 190.007 316.816 193.863 314.714L459.754 169.69C463.336 167.737 467.664 167.737 471.246 169.69Z",
    stroke: "#86FBF0",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.203 185.933L721.64 321.958C726.138 324.411 728.937 329.125 728.937 334.249V604.751C728.937 609.875 726.138 614.589 721.639 617.042L472.203 753.067C468.025 755.345 462.975 755.345 458.797 753.067L209.36 617.042C204.862 614.589 202.063 609.875 202.063 604.751V334.249C202.063 329.125 204.862 324.411 209.36 321.958L458.797 185.933C462.975 183.655 468.025 183.655 472.203 185.933Z",
    stroke: "#86FBF0",
    strokeWidth: 4
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M471.246 169.69L737.137 314.714C740.992 316.816 743.391 320.857 743.391 325.248V613.752C743.391 618.143 740.992 622.184 737.137 624.286L471.246 769.31C467.664 771.263 463.336 771.263 459.754 769.31L193.863 624.286C190.007 622.184 187.609 618.143 187.609 613.752V325.248C187.609 320.857 190.007 316.816 193.863 314.714L459.754 169.69C463.336 167.737 467.664 167.737 471.246 169.69Z",
    stroke: "#86FBF0",
    strokeWidth: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M472.203 185.933L721.64 321.958C726.138 324.411 728.937 329.125 728.937 334.249V604.751C728.937 609.875 726.138 614.589 721.639 617.042L472.203 753.067C468.025 755.345 462.975 755.345 458.797 753.067L209.36 617.042C204.862 614.589 202.063 609.875 202.063 604.751V334.249C202.063 329.125 204.862 324.411 209.36 321.958L458.797 185.933C462.975 183.655 468.025 183.655 472.203 185.933Z",
    stroke: "#86FBF0",
    strokeWidth: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 465.5,
    cy: 469.5,
    r: 349.5,
    stroke: "#86FBF0",
    strokeWidth: 8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M461.973 84.0119C540.829 83.3935 617.982 106.942 683.052 151.489C748.123 196.036 797.988 259.445 825.939 333.183",
    stroke: "#86FBF0",
    strokeWidth: 8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M476.404 855.832C413.1 857.703 350.308 843.969 293.566 815.841C236.823 787.714 187.873 746.057 151.032 694.544",
    stroke: "#86FBF0",
    strokeWidth: 8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M135.391 670.883C110.212 629.568 93.0238 583.888 84.7231 536.223",
    stroke: "#86FBF0",
    strokeWidth: 8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M850.49 450.168C848.861 418.496 843.335 387.147 834.036 356.827",
    stroke: "#86FBF0",
    strokeWidth: 8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 465,
    cy: 470,
    r: 372,
    stroke: "#86FBF0",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_707_130",
    x: 0.782227,
    y: 0,
    width: 933.703,
    height: 940,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40,
    result: "effect1_foregroundBlur_707_130"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_707_130",
    x: 103.608,
    y: 84.2256,
    width: 723.783,
    height: 770.549,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40,
    result: "effect1_foregroundBlur_707_130"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCastingCircle);
export default __webpack_public_path__ + "static/media/casting_circle.2283243ba47a387ee0e2c5dcc050f0ea.svg";
export { ForwardRef as ReactComponent };